export default "__VITE_ASSET__CS2Nlf$j__"